import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon, ChevronUpIcon, ChevronDownIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
// Mock data for a single soggetto proponente
const soggettoData = {
  id: 1,
  denominazione: 'Associazione Culturale Test Nuove Opere',
  formaGiuridica: 'Società a responsabilità limitata - S.R.L.',
  dataCostituzione: '15/03/2015',
  indirizzoSedeLegale: 'Via Roma 1',
  citta: 'Roma',
  regione: 'Lazio',
  provincia: 'RM',
  cap: '00100',
  residenzaSedeLegale: 'Italia',
  partitaIva: '12345678901',
  codiceFiscale: 'RSSMRA90A01H501Z',
  codiceMeccanografico: '',
  rappresentanteLegale: {
    nome: 'Mario',
    cognome: 'Verdi',
    codiceFiscale: 'RSSMRA90A01H501Z',
    telefono: '+39 333 1234567',
    email: 'bando3.mario.verdi@yopmail.com',
    dataScadenzaDocumento: '01/01/2028'
  },
  contatto: {
    email: 'bando3.mario.verdi@yopmail.com',
    pec: 'pec.mario.verdi@yopmail.com',
    telefono: '+39 333 1234567',
    sitoWeb: '',
    socialNetwork: ''
  },
  utente: {
    nome: 'Monica',
    cognome: 'Ricci',
    email: 'filomena28@example.net'
  }
};
function AccordionSection({
  title,
  children,
  defaultOpen = true
}: {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div style={{
    marginBottom: '24px'
  }} data-id="element-1715">
      <div className="flex justify-between items-center cursor-pointer" style={{
      marginBottom: isOpen ? '16px' : '0'
    }} onClick={() => setIsOpen(!isOpen)} data-id="element-1716">
        <h3 style={{
        fontSize: '18px',
        fontWeight: 500,
        color: '#293B54',
        fontFamily: 'Roboto, sans-serif',
        margin: 0
      }} data-id="element-1717">
          {title}
        </h3>
        <button type="button" className="flex items-center gap-1" style={{
        color: '#2A97DF',
        fontSize: '14px',
        fontFamily: 'Roboto, sans-serif',
        background: 'none',
        border: 'none',
        cursor: 'pointer'
      }} data-id="element-1718">
          {isOpen ? 'Vedi meno' : 'Vedi più'}
          {isOpen ? <ChevronUpIcon size={16} data-id="element-1719" /> : <ChevronDownIcon size={16} data-id="element-1720" />}
        </button>
      </div>
      {isOpen && children}
    </div>;
}
function ReadOnlyField({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <div style={{
    marginBottom: '16px'
  }} data-id="element-1721">
      <label style={{
      fontSize: '13px',
      color: '#80858E',
      fontFamily: 'Roboto, sans-serif',
      display: 'block',
      marginBottom: '4px'
    }} data-id="element-1722">
        {label}
      </label>
      <div style={{
      padding: '12px 16px',
      backgroundColor: '#F4F4F4',
      fontSize: '14px',
      color: '#444444',
      fontFamily: 'Roboto, sans-serif',
      borderRadius: '8px'
    }} data-id="element-1723">
        {value || '-'}
      </div>
    </div>;
}
export function SoggettoProponenteDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  return <div className="space-y-6" data-id="element-1724">
      {/* Back Link */}
      <Link to="/soggetti-proponenti" className="inline-flex items-center gap-1 text-sm font-roboto hover:underline" style={{
      color: '#2A97DF'
    }} data-id="element-1725">
        <ArrowLeftIcon size={14} data-id="element-1726" />
        Torna alla lista
      </Link>

      {/* Header Card */}
      <div className="bg-white p-8" style={{
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      borderRadius: '8px'
    }} data-id="element-1727">
        <div className="flex justify-between items-start" data-id="element-1728">
          <div data-id="element-1729">
            <h1 style={{
            fontSize: '28px',
            fontWeight: 400,
            color: '#293B54',
            fontFamily: 'Roboto, sans-serif',
            margin: 0,
            marginBottom: '8px'
          }} data-id="element-1730">
              {soggettoData.denominazione}
            </h1>
            <p style={{
            fontSize: '14px',
            color: '#80858E',
            fontFamily: 'Roboto, sans-serif',
            margin: 0
          }} data-id="element-1731">
              ID: {id}
            </p>
          </div>
          <Button variant="outlined" data-id="element-1732">MODIFICA</Button>
        </div>
      </div>

      {/* Content Card */}
      <div className="bg-white p-8" style={{
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      borderRadius: '8px'
    }} data-id="element-1733">
        <AccordionSection title="Dati Soggetto Proponente" data-id="element-1734">
          <ReadOnlyField label="Denominazione Soggetto Proponente" value={soggettoData.denominazione} data-id="element-1735" />
          <ReadOnlyField label="Forma Giuridica" value={soggettoData.formaGiuridica} data-id="element-1736" />
          <ReadOnlyField label="Data di costituzione" value={soggettoData.dataCostituzione} data-id="element-1737" />
          <ReadOnlyField label="Indirizzo sede legale" value={soggettoData.indirizzoSedeLegale} data-id="element-1738" />
          <div className="grid grid-cols-2 gap-4" data-id="element-1739">
            <ReadOnlyField label="Città" value={soggettoData.citta} data-id="element-1740" />
            <ReadOnlyField label="Regione" value={soggettoData.regione} data-id="element-1741" />
          </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-1742">
            <ReadOnlyField label="Provincia" value={soggettoData.provincia} data-id="element-1743" />
            <ReadOnlyField label="CAP" value={soggettoData.cap} data-id="element-1744" />
          </div>
          <ReadOnlyField label="Residenza sede legale" value={soggettoData.residenzaSedeLegale} data-id="element-1745" />
          <ReadOnlyField label="Partita IVA" value={soggettoData.partitaIva} data-id="element-1746" />
          <ReadOnlyField label="Codice fiscale del soggetto proponente" value={soggettoData.codiceFiscale} data-id="element-1747" />
          <ReadOnlyField label="Codice Meccanografico" value={soggettoData.codiceMeccanografico} data-id="element-1748" />
        </AccordionSection>

        <AccordionSection title="Rappresentante Legale" data-id="element-1749">
          <div className="grid grid-cols-2 gap-4" data-id="element-1750">
            <ReadOnlyField label="Nome" value={soggettoData.rappresentanteLegale.nome} data-id="element-1751" />
            <ReadOnlyField label="Cognome" value={soggettoData.rappresentanteLegale.cognome} data-id="element-1752" />
          </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-1753">
            <ReadOnlyField label="Codice fiscale" value={soggettoData.rappresentanteLegale.codiceFiscale} data-id="element-1754" />
            <ReadOnlyField label="Telefono" value={soggettoData.rappresentanteLegale.telefono} data-id="element-1755" />
          </div>
          <ReadOnlyField label="Email" value={soggettoData.rappresentanteLegale.email} data-id="element-1756" />
          <ReadOnlyField label="Data scadenza documento d'identità" value={soggettoData.rappresentanteLegale.dataScadenzaDocumento} data-id="element-1757" />
        </AccordionSection>

        <AccordionSection title="Informazioni di Contatto" data-id="element-1758">
          <ReadOnlyField label="Email" value={soggettoData.contatto.email} data-id="element-1759" />
          <ReadOnlyField label="PEC" value={soggettoData.contatto.pec} data-id="element-1760" />
          <ReadOnlyField label="Telefono" value={soggettoData.contatto.telefono} data-id="element-1761" />
          <ReadOnlyField label="Sito Web" value={soggettoData.contatto.sitoWeb} data-id="element-1762" />
          <ReadOnlyField label="Social Network" value={soggettoData.contatto.socialNetwork} data-id="element-1763" />
        </AccordionSection>

        <AccordionSection title="Utente Associato" data-id="element-1764">
          <div className="grid grid-cols-2 gap-4" data-id="element-1765">
            <ReadOnlyField label="Nome" value={soggettoData.utente.nome} data-id="element-1766" />
            <ReadOnlyField label="Cognome" value={soggettoData.utente.cognome} data-id="element-1767" />
          </div>
          <ReadOnlyField label="Email" value={soggettoData.utente.email} data-id="element-1768" />
        </AccordionSection>
      </div>
    </div>;
}